module.exports = __webpack_public_path__ + "static/media/RPR 1a2.5a7573fb.jpg";